import CountryCodeSelector from '@/components/CountryCodeSelector/index';
import { CustomBirthDate } from '@/components/CustomBirthDate';
import NationalitySelector from '@/components/NationalitySelector';
import { Title } from '@/components/Title';
import { useWidgetConfig } from '@/context/WidgetConfigContext';
import { COLORS } from '@/helpers/constants/theme';
import { useUnregisteredCustomerContext } from '@/views/UnregisteredCustomer/context/UnregisteredCustomerContext';

export function FormStep() {
  const { showNationality } = useWidgetConfig();
  const {
    phoneNumber,
    setPhoneNumber,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    title,
    setTitle: setTitleFromContext,
    birthDate,
    setBirthDate,
    nationality,
    setNationality,
    errors,
    setErrors,
    savedFirstName,
    savedLastName,
    isSubmitting,
    onRegister,
    hoverBackground,
    hoverHandlers,
    textColor,
  } = useUnregisteredCustomerContext();

  return (
    <>
      <div
        className='space-y-2'
        style={{
          animation: 'fadeInSlideUp 0.3s ease-out forwards',
        }}
      >
        <style>{`
          @keyframes fadeInSlideUp {
            from {
              opacity: 0;
              transform: translateY(8px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}</style>

        <div className='flex w-full gap-0'>
          <div className='w-28 flex-shrink-0 bg-gray-50'>
            <CountryCodeSelector />
          </div>
          <input
            className='w-full rounded-r-md border border-l-0 border-gray-300 px-2 py-2 text-sm'
            placeholder='Phone Number'
            value={phoneNumber}
            onInput={(e) => {
              setPhoneNumber((e.target as HTMLInputElement).value);
              setErrors((prev) => ({ ...prev, phoneNumber: undefined }));
            }}
          />
        </div>
        {errors.phoneNumber && <h6 className='!text-red-600'>{errors.phoneNumber}</h6>}

        <Title
          title={title}
          setTitle={(action) => {
            const value = typeof action === 'function' ? action(title) : action;
            setTitleFromContext(value);
            setErrors((prev) => ({ ...prev, title: undefined }));
          }}
          error={errors.title}
        />

        {!savedFirstName && (
          <>
            <input
              className='w-full rounded-md border px-2 py-2 text-sm'
              placeholder='First Name'
              value={firstName}
              onInput={(e) => {
                setFirstName((e.target as HTMLInputElement).value);
                setErrors((prev) => ({ ...prev, firstName: undefined }));
              }}
            />
            {errors.firstName && <h6 className='!text-red-600'>{errors.firstName}</h6>}
          </>
        )}

        {!savedLastName && (
          <input
            className='w-full rounded-md border px-2 py-2 text-sm'
            placeholder='Last Name (optional)'
            value={lastName}
            onInput={(e) => setLastName((e.target as HTMLInputElement).value)}
          />
        )}

        {showNationality && (
          <NationalitySelector
            value={nationality}
            onChange={(isoCode) => {
              setNationality(isoCode);
              setErrors((prev) => ({ ...prev, nationality: undefined }));
            }}
            error={errors.nationality}
          />
        )}

        <CustomBirthDate
          date={birthDate}
          onChange={setBirthDate}
          error={errors.birthDate}
          onError={(message) => setErrors((prev) => ({ ...prev, birthDate: message }))}
        />
      </div>

      <button
        onClick={onRegister}
        {...hoverHandlers}
        disabled={isSubmitting}
        className={`w-full rounded-lg px-4 py-3 font-semibold transition-colors ${
          isSubmitting ? 'cursor-not-allowed' : 'cursor-pointer'
        }`}
        style={{
          backgroundColor: isSubmitting ? COLORS.DISABLED_DARK : hoverBackground,
          color: isSubmitting ? COLORS.DISABLED_LIGHT : textColor,
        }}
      >
        {isSubmitting ? 'Registering...' : 'Register in loyalty'}
      </button>

      <h6 className='text-center'>Unlock benefits & rewards with a quick update.</h6>
    </>
  );
}
